import { render, staticRenderFns } from "./GetSidModal.vue?vue&type=template&id=74c19254"
import script from "./GetSidModal.vue?vue&type=script&lang=js"
export * from "./GetSidModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports